import dumpState from './dump-state.js';

export default {
    dumpState
};
